module.exports = __webpack_public_path__ + "img/heang_chanthy.64d6ac46.png";